import { useDiscoverySettingsContext } from '../../composition/DiscoverySettings/discoverySettingsContext';
import { SearchableSection } from '../DiscoverySearch/SearchableSection';
import { DeviceAttributesList } from './DeviceAttributesList';

type Props = {
  fetchCount: () => void;
};

export const DeviceAttributes = (props: Props) => {
  const discoverySettingsContext = useDiscoverySettingsContext();

  return (
    <div className='flex-1 flex flex-col gap'>
      <div className='text-level-4 font-semibold font-heading'>
        Device attributes
      </div>
      {discoverySettingsContext.snapshotId ? (
        <SearchableSection
          id='device-attributes-list'
          className='flex-1 flex flex-col'
          wrapperClassName='flex-1 flex flex-col'
        >
          <DeviceAttributesList
            snapshotId={discoverySettingsContext.snapshotId}
            onUpdated={props.fetchCount}
          />
        </SearchableSection>
      ) : (
        'Cannot load device attributes without a snapshot selected.'
      )}
    </div>
  );
};
